import { RequestListContainer } from '@/components/containers/RequestListContainer'
import { RequestListsView } from '@/components/views/requestLists/RequestListsView'

const RequestListPage = () => <RequestListContainer View={(props) => <RequestListsView {...props} />} />

export default RequestListPage
